import {http_client} from "@/plugins/http_client";

const url = '/api/v1/instituciones'
const getInstituciones = async (params = {}) => await http_client(`${url}/`, params, 'get')

export default {
    getInstituciones,
}